import React from "react";

const AccountDeletion = () => {
	return (
		<div style={{ padding: "20px" }}>
			<h2>Eliminación de cuenta en Needex</h2>
			<p>
				Si deseas eliminar tu cuenta de Needex y los datos asociados, sigue los
				pasos que se indican a continuación:
			</p>
			<ol>
				<li>
					Envía un correo electrónico a nuestro equipo de soporte:{" "}
					<a href="mailto:romjosdev@gmail.com">romjosdev@gmail.com</a> indicando
					en el asunto <strong>“Eliminar cuenta Needex”</strong>.
				</li>
				<li>
					Incluye en el mensaje el correo electrónico con el que te registraste
					en Needex.
				</li>
				<li>
					Nuestro equipo verificará tu identidad y procederá con la eliminación
					de tu cuenta en un plazo máximo de <strong>7 días hábiles</strong>.
				</li>
			</ol>

			<h3>Datos que se eliminan</h3>
			<p>Al eliminar tu cuenta se borrarán:</p>
			<ul>
				<li>
					Tu perfil de usuario (nombre, correo electrónico, foto de perfil).
				</li>
				<li>Tu historial de solicitudes y servicios.</li>
				<li>Los tokens de dispositivos usados para notificaciones.</li>
			</ul>

			<h3>Datos que se conservan</h3>
			<p>
				Conservamos únicamente la información necesaria por motivos legales y de
				seguridad, como registros de pagos o facturación, durante un periodo
				máximo de <strong>6 meses</strong>. Pasado ese tiempo, estos datos
				también serán eliminados.
			</p>

			<h3>Contacto</h3>
			<p>
				Para cualquier duda, comunícate con nuestro soporte en la aplicación
				Needex o a través del correo{" "}
				<a href="mailto:romjosdev@gmail.com">romjosdev@gmail.com</a>.
			</p>
		</div>
	);
};

export default AccountDeletion;
